import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import { ReactComponent as DeleteIcon } from '../../../assets/images/delete.svg';
import { ReactComponent as DocumentIcon } from '../../../assets/images/document.svg';
import { IsMobile } from '../../../helpers/IsMobile';

import styles from './FileUpload.module.scss';

const FileUpload = ({ acceptedFiles = [], handleFileDelete, handleOnDrop, accept, DropzoneIcon }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  const { getRootProps, getInputProps, open } = useDropzone({
    accept,
    noClick: true,
    noKeyboard: true,
    multiple: false,
    onDrop: handleOnDrop,
  });

  return (
    <div>
      <div className={styles.dndWindow}>
        <div className={styles.dndWindowHeader}>
          <div className={styles.windowHeaderActions}>
            <div className={styles.circleDiv} />
            <div className={styles.circleDiv} />
            <div className={styles.circleDiv} />
          </div>
        </div>
        <div className={styles.dndZone}>
          <div
            {...getRootProps({
              className: styles.dropzone,
            })}
          >
            <div className={styles.fileList}>
              {acceptedFiles.map((file) => (
                <div key={file.path + Math.random()}>
                  <div>
                    <DocumentIcon />
                    <span className={styles.uploadedFileName}>{file.name}</span>
                  </div>
                  <div className={styles.deleteFile} onClick={() => handleFileDelete?.(file)} role="presentation">
                    <DeleteIcon />
                  </div>
                </div>
              ))}
            </div>
            <input {...getInputProps()} />
            <div className={styles.dropzoneContent}>
              <DropzoneIcon />
              <div>
                {isMobile ? (
                  <p>
                    <span onClick={open} role="presentation">
                      {t('fileUpload.browse')}
                    </span>
                    <br />
                    {t('fileUpload.yourFile')}
                  </p>
                ) : (
                  <>
                    <p>{t('fileUpload.dragDrop')}</p>
                    <p>
                      {t('fileUpload.yourFileOr')}&nbsp;
                      <span onClick={open} role="presentation">
                        {t('fileUpload.browse').toLowerCase()}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
